import { render } from "./WebphoneAgenda.vue?vue&type=template&id=275c4eea&scoped=true"
import script from "./WebphoneAgenda.vue?vue&type=script&lang=js"
export * from "./WebphoneAgenda.vue?vue&type=script&lang=js"

import "./WebphoneAgenda.vue?vue&type=style&index=0&id=275c4eea&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275c4eea"]])

export default __exports__